import { useFormatMessage } from '@zennolab_platform/webui-sdk/dist/hooks';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef } from 'react';
import { Navigate, NavLink, Route, Routes } from 'react-router-dom';
import { Container } from 'typedi';

import { config } from '../../config';
import { SessionStore } from '../../stores/SessionStore';
import { isEmbedded, reportHeightToParent, revealModalsInParent } from '../../utils/embedding';
import { NoAccess, NotFound } from '../screens';
import { sections } from './sections';
import { EmbeddedFrameStyle, Frame, SideNav } from './styled';

/** UA2 already names the section with its own tab. */
const embedded = isEmbedded;

export const Shell = observer(function Shell() {
  const { roles } = Container.get(SessionStore);
  const { t } = useFormatMessage();
  const allowed = sections.filter(section => roles.includes(section.role));
  const frameRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!embedded() || !frameRef.current) return undefined;
    document.documentElement.dataset.embedded = 'true';
    const stopHeight = reportHeightToParent(frameRef.current);
    const stopModals = revealModalsInParent();
    return () => {
      stopHeight();
      stopModals();
    };
  }, []);

  return (
    <Frame ref={frameRef}>
      {embedded() && <EmbeddedFrameStyle />}
      {!embedded() && (
        <SideNav
          aria-label={t({
            id: 'shell.nav.label',
            defaultMessage: 'Разделы',
            description: 'Подпись бокового меню разделов',
          })}
        >
          {allowed.map(section => (
            <NavLink key={section.path} to={`/${section.path}`}>
              {section.title(t)}
            </NavLink>
          ))}
          {config.version && <small>v{config.version}</small>}
        </SideNav>
      )}
      <Routes>
        <Route path="/" element={allowed.length > 0 ? <Navigate to={`/${allowed[0].path}`} replace /> : <NoAccess />} />
        {sections.map(section => (
          <Route
            key={section.path}
            path={`/${section.path}/*`}
            element={roles.includes(section.role) ? section.element : <NoAccess />}
          />
        ))}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Frame>
  );
});
